import React from "react";
import '../assets/css/Style.css';

const RecentPayments = ({ columns, rows }) => {
    return (
            <table className="recent-payments-table table table-striped" tabIndex={0}>
                <thead className="recent-payments-header sticky-top">
                    <tr className="recent-payments-row paymentsbackground">
                        {
                            columns && columns?.map((item, index) => (
                                <th key={index} scope="col" className="recent-payments-column-header">
                                    {item}
                                </th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody className="recent-payments-body">
                    {rows && rows?.map((item, index) => (
                        <tr key={index} className="recent-payments-row">
                            <td className="recent-payments-cell">{item?.bill_total_amount_due}</td>
                            <td className="recent-payments-cell">{item?.adjustment}</td>
                            <td className="recent-payments-cell">{item?.payment}</td>
                            <td className="recent-payments-cell">{item?.netdue}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            
    )
}

export default RecentPayments;